// extracted by mini-css-extract-plugin
export var container = "_kw-0";
export var dotAnimation = "_kw-2";
export var dotsLoading = "_kw-1";